module.exports = __webpack_public_path__ + "static/img/好耶300x300.da733b87.png";